import AuthService from '@/common/services/auth.service';

export const IsAuthGuard = (to, from, next) => {
  if (!AuthService.isAuthenticated()) {
    return next({name: 'home'});
  }

  return next();
};
